import { Router } from 'pjax';
import form from './form.js';

Router.get('entry-form/entrant/start', form);
Router.get('entry-form/entrant/([a-zA-Z]+)/edit', form);
Router.get('entry-form/manager/start', form);
Router.get('entry-form/manager/([a-zA-Z]+)/edit', form);
